import { gql } from '@apollo/client';

export const AppBaseFields = gql`
  fragment AppBaseFields on App {
    id
    name
    criticality
    unclaimed
    owned
    ownerName
    logoUrl
    taskCounts {
      criticality
      count
    }
    policy {
      update
      remove
    }
  }
`;
